export default function getResource(label, vars = []) {
    const resources = {
        promotionalTexts: 'Promotional Texts',
        description: 'Sign up for Sephora Texts and never miss out on exclusive releases, events, and offers.',
        status: 'Status:',
        subscribed: 'Subscribed',
        notSubscribed: 'Not Subscribed',
        subscribe: 'Subscribe',
        edit: 'Edit',
        confirmationPrefix: 'We sent a confirmation to ',
        confirmationSuffix: '. Reply Y to subscribe. Didn\'t get it?',
        resend: 'Resend'
    };
    return resources[label];
}
